import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';

/**
 * A directly-linkable /logout route: calls POST /auth/logout, clears the
 * in-memory session, and sends the user back to /login. (UserAvatarButton's
 * dropdown also offers sign-out inline without the extra navigation.)
 */
export function LogoutPage() {
  const status = useAuthStore((s) => s.status);

  useEffect(() => {
    void useAuthStore.getState().logout();
  }, []);

  if (status === 'authenticated') return null;
  return <Navigate to="/login" replace />;
}
